module.exports = __webpack_public_path__ + "img/bg-container.aa88a7e7.png";